import { combineReducers } from 'redux';
import { fetchTransporterShareTrack } from './redTransporter-ShareTracker.jsx';

const rootReducer = combineReducers({
    transporterShareTrackStore: fetchTransporterShareTrack,
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx